export const saveToken = (token: string) => {
  sessionStorage.setItem("token", token);
};

export const getToken = () => {
  return sessionStorage.getItem("token");
};

export const removeSessionToken = () => {
  sessionStorage.removeItem("token");
};

export const isUserLoggedIn = () => {
  return sessionStorage.getItem("token") !== null;
};
export const saveRefreshToken = (refreshToken: string) => {
  sessionStorage.setItem("refreshToken", refreshToken);
};

export const getRefreshToken = () => {
  return sessionStorage.getItem("refreshToken");
};
